'use client';

import React from 'react';
import { Button } from '@heroui/react';
import { Icon } from '@iconify/react';
import { ResponsiveTooltip } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';
import { RevshareCampaign } from '../types';

interface ActionsCellProps {
  campaign: RevshareCampaign;
  onShowContent: (campaign: RevshareCampaign) => void;
  onStopCampaign: (campaign: RevshareCampaign) => void;
}

const ActionsCell: React.FC<ActionsCellProps> = ({ campaign, onShowContent, onStopCampaign }) => {
  const { t } = useTranslations();

  // Check if campaign is active (in_progress)
  const isActive = campaign.status === 'in_progress';

  const handleStopCampaign = () => {
    if (isActive) {
      onStopCampaign(campaign);
    }
  };

  return (
    <div className="flex items-center gap-2 py-2">
      {/* Show Content Button */}
      <Button
        size="sm"
        className="bg-[#E6F1FE] text-partner h-8 rounded-2 px-3.5 text-xs font-normal"
        onPress={() => onShowContent(campaign)}
      >
        {t('partner.revshare.campaigns.showContent') || 'Показать контент'}
      </Button>

      {/* Stop Campaign Button - only show for active campaigns */}
      {isActive && (
        <ResponsiveTooltip content={t('partner.partnerCampaigns.stopCampaignTooltip')} placement="top">
          <Button
            isIconOnly
            size="sm"
            className="w-8 h-8 min-w-8 rounded-2 bg-partner text-white"
            onPress={handleStopCampaign}
          >
            <Icon icon="solar:stop-bold" width={16} height={16} />
          </Button>
        </ResponsiveTooltip>
      )}
    </div>
  );
};

export default ActionsCell;
